// extracted by mini-css-extract-plugin
export var bounce = "_n1-1";
export var generatingText = "_n1-6";
export var lightning = "_n1-4";
export var popup = "_n1-5";
export var progressBar = "_n1-7";
export var progressFill = "_n1-8";
export var progressShimmer = "_n1-9";
export var progressText = "_n1-a";
export var shimmer = "_n1-3";
export var uploadIcon = "_n1-0";
export var uploadingText = "_n1-2";